module.exports = __webpack_public_path__ + "img/hk.7c4469ac.png";